import globalStyles from '../../styles/exported.module.scss';

export const UncheckedIcon = ({ className, ...rest }: { className?: string } & Partial<HTMLOrSVGElement>) => (
  <svg
    {...(className && { className })}
    {...rest}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="24"
    viewBox="0 0 20 24"
    fill="none"
  >
    <rect
      x="0.5"
      y="2.5"
      width="18.9957"
      height="19"
      rx="3.5"
      fill={globalStyles.bdPureWhite}
      stroke={globalStyles.bdPrimaryNavy}
    />
  </svg>
);
